import { render, staticRenderFns } from "./ProductMails.vue?vue&type=template&id=7a4cd2b2&scoped=true&"
import script from "./ProductMails.vue?vue&type=script&lang=ts&"
export * from "./ProductMails.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMails.vue?vue&type=style&index=0&id=7a4cd2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4cd2b2",
  null
  
)

export default component.exports